/**
 * Namespace de tradução para autorização e controle de acesso.
 * Inclui mensagens de erro, avisos e labels relacionados a permissões.
 */

import { createTranslationRef } from '@backstage/core-plugin-api/alpha';
export const permissionsTranslationRef = createTranslationRef({
  id: 'app.permissions',
  messages: {
    error: {
      unauthorized: 'You are not authenticated. Please log in.',
      forbidden: 'You do not have permission to access this resource.',
      insufficientPermissions: 'Insufficient permissions to perform this action.',
      adminOnly: 'This action is restricted to administrators only.',
      readOnly: 'You have read-only access to this resource.',
      accessDenied: 'Access denied.',
      noPermission: 'You do not have the required permission.',
    },
    warning: {
      restrictedArea: 'You are accessing a restricted area.',
      limitedAccess: 'Your access to this resource is limited.',
      requiresAuth: 'Authentication required to access this feature.',
      elevatedPrivileges: 'This action requires elevated privileges.',
    },
    message: {
      contactAdmin: 'Contact your administrator to request access.',
      permissionRequired: 'Permission required to access this feature.',
      loginRequired: 'Please log in to continue.',
      checkPermissions: 'Please check your permissions and try again.',
    },
    label: {
      permissions: 'Permissions',
      role: 'Role',
      accessLevel: 'Access Level',
      user: 'User',
      group: 'Group',
      admin: 'Administrator',
      viewer: 'Viewer',
      editor: 'Editor',
    },
  },
});
